import React, { Component } from "react"
import LangEgiftHeader from "../../resources/modules/LangEgiftHeader"
import { getActiveLanguage, Translate, getTranslate } from "react-localize-redux"
import { connect } from "react-redux"
import styled from "styled-components"
import EgiftHeaderMegaMenu from "./EgiftHeaderMegaMenu"

class EgiftHeader extends Component {
	constructor(props) {
		super(props)
		this.state = {
			navItems: LangEgiftHeader.navbar.items,
			openedMenu: null,
			inStyledNavLink: null,
			inMega: null,
			navControlOpened: false,
		}
	}

	generateNavItems = (item) => {
		const id = `nav_${parseInt(item[item.length - 1]) - 1}`
		const { openedMenu } = this.state
		return (
			<Translate key={item}>
				{(translate) => {
					return (
						<li id={id}>
							<StyledNavLink
								openedMenu={openedMenu === id}
								onMouseEnter={() => this.onStyleNavLinkEnter(id)}
								onMouseLeave={this.onStyleNavLinkLeave}
								href={translate("navbar." + item + ".path")}>
								<strong>{translate("navbar." + item + ".text")}</strong>
							</StyledNavLink>
						</li>
					)
				}}
			</Translate>
		)
	}

	onStyleNavLinkEnter = (i) => {
		this.setState({ openedMenu: i, inStyledNavLink: true })
	}
	onStyleNavLinkLeave = () => {
		this.setState({ inStyledNavLink: false }, () => {
			const { inMega, inStyledNavLink } = this.state
			if (!inMega && !inStyledNavLink) {
				this.setState({ openedMenu: null })
			}
		})
	}

	onMegaNavEnter = () => {
		this.setState({ inMega: true })
	}

	onMegaNavLeave = () => {
		const { inStyledNavLink } = this.state
		if (inStyledNavLink) {
			this.setState({ inMega: false })
		} else {
			this.setState({ openedMenu: null, inMega: false })
		}
	}

	handleNavControlOnClick = () => {
		this.setState({ navControlOpened: !this.state.navControlOpened })
	}

	render() {
		const { currentLanguage } = this.props
		const { openedMenu, navControlOpened } = this.state

		return (
			<HeaderContainer>
				<aside className="notificationBar notificationBar--shop" />
				<Header className="container-fluid">
					<FlexContainer>
						<LeftContainer>
							<Logo
								href={`/${currentLanguage}/`}
								rel="home"
								title="Starbucks Logo">
								<img
									src="https://www.starbucks.vn/media/jlrf0uhs/logo_tcm89-366_w1024_n.png"
									alt="Logo"
									data-aspect={0}
									className="logo"
								/>{" "}
							</Logo>
							<StyledNav>
								<NavControl
									navControlOpened={navControlOpened}
									onClick={this.handleNavControlOnClick}>
									<Hamburger navControlOpened={navControlOpened} />
								</NavControl>
								<NavUl navControlOpened={navControlOpened}>
									{this.state.navItems.map((item) =>
										this.generateNavItems(item)
									)}
								</NavUl>
							</StyledNav>
						</LeftContainer>
						<RightContainer>
							{this.props.currentLanguage === "en" ? (
								<FindAStore
									href={`http://en.starbucks.vn/store-locator`}
									title={<Translate id="navbar.findstore.text" />}>
									<MapIcon aria-hidden="true" data-icon="✪" />
									<FindAStoreText>
										{<Translate id="navbar.findstore.text" />}
									</FindAStoreText>
								</FindAStore>
							) : (
								<FindAStore
									href={`https://www.starbucks.vn:443/b%E1%BB%99-%C4%91%E1%BB%8Bnh-v%E1%BB%8B-c%E1%BB%ADa-h%C3%A0ng`}
									title={<Translate id="navbar.findstore.text" />}>
									<MapIcon aria-hidden="true" data-icon="✪" />
									<FindAStoreText>
										{<Translate id="navbar.findstore.text" />}
									</FindAStoreText>
								</FindAStore>
							)}
						</RightContainer>
					</FlexContainer>
				</Header>

				<EgiftHeaderMegaMenu
					onMegaNavEnter={this.onMegaNavEnter}
					onMegaNavLeave={this.onMegaNavLeave}
					openedMenu={openedMenu}
					translate={this.props.translate}
					currentLanguage={this.props.currentLanguage}
					isAuthenticated={this.props.isAuthenticated}
				/>
			</HeaderContainer>
		)
	}
}

const StyledNav = styled.nav`
	position: relative;
`

const HeaderContainer = styled.div`
	background: #f7f7f7;
`

const Header = styled.header`
	@media screen and (min-width: 1360px) {
		max-width: 1360px;
	}
`

const FindAStoreText = styled.span`
	display: inline;

	@media screen and (max-width: 767px) {
		display: none;
	}
`

const Hamburger = styled.span`
	position: absolute;
	width: 20px;
	height: 20px;
	background: ${(p) => (p.navControlOpened ? "transparent" : "#006341")};
	display: block;
	margin: 12px;
	cursor: pointer;

	&:before,
	&:after {
		content: "";
		position: absolute;
		top: ${(p) => (p.navControlOpened ? "40%" : "20%")};
		left: 0;
		width: 100%;
		height: 20%;
		background: #f7f7f7;
		transition: all ease 0.2s;
		-webkit-transform: translateZ(0);
	}

	&:before {
		transform: ${(p) => (p.navControlOpened ? "rotate(45deg)" : "rotate(0deg)")};
	}

	&:after {
		top: ${(p) => (p.navControlOpened ? "40%" : "60%")};
		transform: ${(p) => (p.navControlOpened ? "rotate(-45deg)" : "rotate(0deg)")};
	}
`

const NavControl = styled.div`
	position: absolute;
	top: -44px;
	right: -12px;
	width: 44px;
	height: 44px;
	display: none;
	background: ${(p) => (p.navControlOpened ? "#1e1e1e" : "transparent")};

	@media screen and (max-width: 767px) {
		display: block;
	}
`

const StyledNavLink = styled.a`
	color: ${(p) => (p.openedMenu ? "white" : "black")}
	background: ${(p) => (p.openedMenu ? "#1e1e1e" : "#f7f7f7")};
	padding: 1rem;
	display: inline-block;
	letter-spacing: .18rem;

	&:hover,
	&:active {
		text-decoration: none;
		color: #f7f7f7;
		background: #1e1e1e;
	}

	@media screen and (max-width: 767px) {
		padding: 3% 8%;
		display:block;
		background: #1e1e1e;
		color: white;
		
		&:hover {
			background:#272727;
		}
	}
`

const NavUl = styled.ul`
	margin: 0;
	margin-left: 1rem;
	padding: 0;
	transition: all ease 0.2s;

	li {
		display: inline-block;

		&:last-child {
			margin: 0;
		}

		@media screen and (max-width: 767px) {
			width: 50%;
		}

		@media screen and (max-width: 480px) {
			width: 100%;
		}
	}

	@media screen and (max-width: 992px) {
		margin: 1rem -1.3rem 0;
	}

	@media screen and (max-width: 767px) {
		padding: ${(p) => (p.navControlOpened ? "2rem 0" : 0)};
		background: #1e1e1e;
		height: ${(p) => (p.navControlOpened ? "157px" : 0)};
		overflow: hidden;
	}

	@media screen and (max-width: 480px) {
		height: ${(p) => (p.navControlOpened ? "auto" : 0)};
	}
`

const LeftContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: flex-end;

	@media screen and (max-width: 992px) {
		display: block;
		margin-top: 1rem;
	}
`

const Logo = styled.a`
	padding: 1rem 0;
`

const MapIcon = styled.span`
	&[data-icon]:before {
		font-family: "Global Icons";
		content: attr(data-icon);
		speak: none;
	}
	color: #006431;
	margin-right: 0.5rem;
	font-size: 2rem;
`

const FindAStore = styled.a`
	color: black;

	&:hover,
	&:active {
		text-decoration: none;
		color: black;
	}
`

const RightContainer = styled.div`
	margin-top: 1rem;

	@media screen and (max-width: 767px) {
		position: absolute;
		right: 5rem;
		top: 3.6rem;
	}

	@media screen and (max-width: 480px) {
		margin-top: auto;
	}
`

const FlexContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`

const mapStateToProps = ({ locale, auth }) => {
	return {
		currentLanguage: getActiveLanguage(locale).code,
		translate: getTranslate(locale),
		isAuthenticated: auth.isAuthenticated,
	}
}

export default connect(mapStateToProps)(EgiftHeader)
